import { GameConfig, GameState, Player, Seat, Card, PlayerReadyForSeating } from '../types';
import { GameStates } from '../constants/GameStates';

/**
 * Base class for all poker game types
 * This allows for expandability to support multiple poker game variants
 */
export abstract class BaseGame {
  protected config: GameConfig;
  protected gameState: GameState;
  protected gameId: string;

  constructor(config: GameConfig, gameId: string) {
    this.config = config;
    this.gameId = gameId;
    this.gameState = {
      state: GameStates.GAME_INIT,
      pot: 0,
      tableCards: [],
      players: [],
      seats: [],
      roomId: '',
      gameId: gameId,
    };
  }

  abstract initiateGame(playersReadyForSeating: PlayerReadyForSeating[]): void;
  abstract updateGameState(newState: GameStates): void;
  abstract dealCards(): void;
  abstract processPlayerAction(playerId: string, action: string, amount?: number): void;

  getGameState(): GameState {
    return { ...this.gameState };
  }

  getConfig(): GameConfig {
    return { ...this.config };
  }

  getGameId(): string {
    return this.gameId;
  }

  protected setPlayers(playersReadyForSeating: PlayerReadyForSeating[]): void {
    this.gameState.players = playersReadyForSeating.map((p) => ({
      uuid: p.playerId,
      name: p.playerName,
      chips: p.chips,
      isMainPlayer: false,
      seatIndex: p.seatIndex,
      isFolded: false,
      isAllIn: false,
      lastRoundBet: 0,
      currentBet: 0,
    }));
  }

  protected initializeSeats(): void {
    this.gameState.seats = Array.from({ length: this.config.numberOfPlayers }, (_, i) => ({
      seatIndex: i,
      isOccupied: false,
    }));
  }
}

